import React from 'react';
import { EV_LOADER_IMAGE_PATH } from 'constants/AppConstants';

function Loader() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100%',
      backgroundColor: 'white',
    }}
    >
      <img
        className="evLogoAnimation"
        src={EV_LOADER_IMAGE_PATH}
        alt="Loading..."
      />
    </div>
  );
}

export default Loader;
